(function(){
  function enhance(){
    document.querySelectorAll('body.cr .cr-prose table, body.cr .cr-trend-table').forEach(function(table){
      if(table.dataset.crEnhanced==='1') return;
      table.dataset.crEnhanced='1';
      var header=table.querySelector('thead tr');
      if(!header) return;
      var heads=Array.prototype.map.call(header.children,function(cell){var copy=cell.cloneNode(true);copy.querySelectorAll('br').forEach(function(br){br.replaceWith(' ');});return (copy.textContent||'').trim().replace(/\s+/g,' ');});
      if(heads.length<3) return;
      if(/activity|industry|business|declared|sector/i.test(heads[1]||'')) table.classList.add('cr-activity-table');
      if(heads.length<4 || table.querySelector('tbody [rowspan],tbody [colspan]')) return;
      table.classList.add('cr-research-cards');
      table.querySelectorAll('tbody tr').forEach(function(row){
        Array.prototype.forEach.call(row.children,function(cell,i){
          if(i>0 && heads[i] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label',heads[i]);
        });
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',enhance,{once:true}); else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();